module.exports = __webpack_public_path__ + "img/text_charactor.e8e6202a.png";